// import 'babel-polyfill';

// @see http://rangeslider.js.org/
import 'rangeslider.js';

// @see https://github.com/liabru/jquery-match-height
import 'jquery-match-height';

// @see https://jquery.com/
import $ from 'jquery';

// Include object polyfill for videos
// @see https://github.com/constancecchen/object-fit-polyfill
import 'objectFitPolyfill';

// Application components
import * as debounce from '@/js/functions/debounce';
import AnchorLocationFixer from '@/js/components/anchorLocationFixer';
import LocalVideo from '@/js/components/localVideo';
import CategoryForm from '@/js/components/categoryForm';
import CssClassToggler from '@/js/components/cssClassToggler';
import DrupalForm from '@/js/components/drupalForm';
import EventMap from '@/js/components/eventMap';
import FloatingElement from '@/js/components/floatingElement';
import HypoCalculator from '@/js/components/hypoCalculator';
import IframeHeightResizer from '@/js/components/iframeHeightResizer';
import ImageCaption from '@/js/components/imageCaption';
import ImageResizer from '@/js/components/imageFullResizer';
import ImageSlider from '@/js/components/imageSlider';
import NavigationToggler from '@/js/components/navigationToggler';
import PollFiller from '@/js/components/pollFiller';
import PublicationOrder from '@/js/components/publicationOrder';
import ResponsiveTable from '@/js/components/responsiveTable';
import Scroller from '@/js/components/scroller';
import ScrollToTheTop from '@/js/components/scrollToTheTop';
import SearchContent from '@/js/components/searchContent';
import Slider from '@/js/components/slider';
import SvgReplacer from '@/js/components/svgReplacer';
import TextController from '@/js/components/textController';
import Video from '@/js/components/video';
import NewsroomSlider from '@/js/components/newsroomSlider';
import TeaserCarousel from '@/js/components/teaserCarousel';
import Newsroom from '@/js/components/newsroom';
import MatomoFormTracking from '@/js/components/matomoFormTracking';
import Anime from '@/js/components/anime';
import Vivus from '@/js/components/vivus';
import ViewportObserver from '@/js/components/ViewportObserver';
import YouTubeVideo from '@/js/components/youTubeVideo';
import CookieAcceptance from '@/js/components/cookieAcceptance';
import CtaNews from '@/js/components/ctaNews';
import HeaderScrollScale from '@/js/components/headerScrollScale';
import PerfectMatch from '@/js/components/perfectMatch';
import InfoOverlay from '@/js/components/infoOverlay';
import Header from '@/js/components/header';
import Footer from '@/js/components/footer';
import CountDown from '@/js/components/countDown';
// import PortalLanguage from '@/js/components/portalLanguage';
import StackedCards from '@/js/components/stackedCards';
import ListWithImage from '@/js/components/listWithImage';
import { VueRelay } from '@/js/VueRelay';
import GoalBasedAdvisoryCarousel from '@/js/components/goalBasedAdvisoryCarousel';
import GoalBasedAdvisoryIntro from '@/js/components/goalBasedAdvisoryIntro';
import HeaderHeroFullBackground from '@/js/components/headerHeroFullBackground';
import ContentBenefitsStackedCards from '@/js/components/contentBenefitsStackedCards';
import ContentFullbackground from '@/js/components/contentFullbackground';
import ContentGbaSustainability from '@/js/components/contentGbaSustainability';
import TeaserMultipleLarge from '@/js/components/teaserMultipleLarge';
import CtaIllustrated from '@/js/components/ctaIllustrated';
import PersonalisedSlider from '@/js/components/personalisedSlider';
import Tooltip from '@/js/components/tooltip';
import ContentBenefits from '@/js/components/contentBenefits';

// Vue
const vueComponents = [
  ['job-finder', () => import('@/js/components/JobFinder.vue')],
  ['fund-saving-plan-wizard', () => import('@/js/components/FundSavingPlanWizard.vue')],
  ['fund-saving-plan-chart', () => import('@/js/components/FundSavingPlanChart.vue')],
  ['fund-saving-plan-illustration', () => import('@/js/components/FundSavingPlanIllustration.vue')],
];

class App {
  constructor() {
    const $html = $('html');
    // Load Events
    const eventMap = new EventMap();

    // Window Events
    window.addEventListener('resize', debounce.debounce(() => {
      eventMap.emit(EventMap.RESIZE);
    }, 150));

    $('.teasertitle').matchHeight();
    $('.teasertext').matchHeight();

    const drupalForm = new DrupalForm({
      formIdentifier: 'form',
    });

    drupalForm.init();

    vueComponents.forEach(([tag, fn]) => VueRelay.parse(tag, fn));

    const slider = new Slider({
      elementDataName: 'slider',
      activeClass: '-show',
    });

    slider.init();

    const scroller = new Scroller({
      elementDataName: 'scroller',
    });

    scroller.init();

    const imageCaption = new ImageCaption({
      imageIdentifier: '.vfx-zoom.-hover',
      captionIdentifier: '.caption',
    });

    imageCaption.init();

    const imageResizer = new ImageResizer({
      imageIdentifier: '[data-image-full-resize]',
    });

    imageResizer.init();

    const cssClassToggler = new CssClassToggler({});
    const floatingElement = new FloatingElement({});
    const hypoCalculator = new HypoCalculator({});
    const iframeHeightResizer = new IframeHeightResizer({});
    const pollFiller = new PollFiller({});
    const publicationOrder = new PublicationOrder({});
    const responsiveTable = new ResponsiveTable({});
    const searchContent = new SearchContent({});
    const textController = new TextController({});
    const video = new Video({});
    const anime = new Anime();
    const vivus = new Vivus();
    const viewportObserver = new ViewportObserver();
    const youTubeVideo = new YouTubeVideo();
    const cookieAcceptance = new CookieAcceptance();
    const ctaNews = new CtaNews();
    const headerScrollScale = new HeaderScrollScale();
    const perfectMatch = new PerfectMatch();
    const infoOverlay = new InfoOverlay();
    const scrollToTheTop = new ScrollToTheTop();
    const header = new Header();
    const footer = new Footer();
    const countDown = new CountDown();
    // const portalLanguage = new PortalLanguage();
    const stackedCards = new StackedCards();
    const listWithImage = new ListWithImage();
    const matomoFormTracking = new MatomoFormTracking();
    const personalisedSlider = new PersonalisedSlider();

    const svgReplacer = new SvgReplacer({
      svgClass: 'svg-inline',
    });

    this.categoryForm = new CategoryForm({
      $el: $('[data-category-form]'),
      $container: $('[data-categories]'),
      targetSelector: '[data-category]',
    });

    cssClassToggler.init();
    floatingElement.init();
    hypoCalculator.init();
    iframeHeightResizer.init();
    pollFiller.init();
    publicationOrder.init();
    responsiveTable.init();
    searchContent.init();
    svgReplacer.init();
    textController.init();
    video.init();
    anime.init();
    vivus.init();
    viewportObserver.init();
    youTubeVideo.init();
    cookieAcceptance.init();
    ctaNews.init();
    headerScrollScale.init();
    perfectMatch.init();
    infoOverlay.init();
    scrollToTheTop.init();
    header.init();
    footer.init();
    countDown.init();
    //    portalLanguage.init();
    stackedCards.init();
    listWithImage.init();
    matomoFormTracking.init();
    personalisedSlider.init();

    Newsroom.create({ video, textController });
    NewsroomSlider.create({});
    TeaserCarousel.create({});
    ImageSlider.create({});
    GoalBasedAdvisoryCarousel.create({});
    GoalBasedAdvisoryIntro.create({});
    ContentBenefitsStackedCards.create({});
    HeaderHeroFullBackground.create({});
    ContentFullbackground.create({});
    TeaserMultipleLarge.create({});
    CtaIllustrated.create({});
    ContentBenefits.create({});
    ContentGbaSustainability.create({});
    Tooltip.create({});

    // Initialize rangeslider.js polyfill
    $('input[type="range"]').rangeslider({
      polyfill: false,
      rangeClass: 'slider-range',
      disabledClass: '-disabled',
      horizontalClass: '-horizontal',
      verticalClass: '-vertical',
      fillClass: 'fill',
      handleClass: 'knob',
    });

    // Initialize meta navigation
    $('[data-nav-meta]').each((index, item) => {
      const navigationToggler = new NavigationToggler({
        item,
        handlerSelector: '[data-handler]',
        handlerTargetSelector: '> [data-target]',
      });

      navigationToggler.init();
    });

    // Initialize main navigation
    const $pageHeader = $('[data-page-header]');
    $('[data-nav-main]').each((index, item) => {
      const navigationToggler = new NavigationToggler({
        item,
        handlerSelector: '[data-handler]',
        handlerTargetSelector: '+ [data-target]',
        onTargetShow: () => {
          $pageHeader.addClass('open');
        },
        onTargetHideAll: () => {
          $pageHeader.removeClass('open');
        },
      });

      navigationToggler.init();
    });

    // Initialize the hero special animations/videos
    const $localVideos = $('[data-local-video]');
    $localVideos.each((index, item) => {
      const localVideo = new LocalVideo({
        item,
      });

      localVideo.init();

      eventMap.on(EventMap.RESIZE, () => {
        localVideo.updateOnResize();
      });
    });

    // Handle onResize
    eventMap.on(EventMap.RESIZE, () => {
      floatingElement.updateOnResize();
      imageCaption.updateOnResize();
      imageResizer.updateOnResize();
      slider.updateOnResize();
      scroller.updateOnResize();
      textController.updateOnResize();
      responsiveTable.updateOnResize();
    });

    // Handle country-switch submit
    $('[data-country-switch]').on('submit', (e) => {
      e.preventDefault();
      const $form = $(e.currentTarget);
      const url = $form.find($form.attr('data-country-switch-selector')).val();
      if (url && url.length > 1) document.location = url;
    });

    // POR-987 Offset anchor locations by header height
    const anchorLocationFixer = new AnchorLocationFixer({
      offsetValue: -$pageHeader.outerHeight(),
    });

    // Initialize anchor fixer on load, this should work for most browsers
    $(window).on('load', () => {
      // For IE, we have to perform some shitty magic since they seem to be having
      // issues reporting values for window.pageYOffset other than 0 on page load
      // @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8605539/
      // @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9453934/
      if ($html.hasClass('no-objectfit')) {
        setTimeout(() => {
          anchorLocationFixer.init();
        }, 200);
      } else {
        anchorLocationFixer.init();
      }

      const language = $('html')[0].lang.split('-')[0];
      $.ajax({
        url: `/portal/public/language/${language}`,
        type: 'GET',
      });
    });

    // Fix anchor links on hash change as well
    $(window).on('hashchange', () => {
      anchorLocationFixer.init();
    });

    // Open first accordion on load?
    $('[data-accordion-open-first]')
      .find('.accordion-element')
      .first()
      .find('.accordionheader')
      .trigger('click');

    // Check if vertical scrollbar is present
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollBarClass = scrollBarWidth > 0 ? '-has-vertical-scrollbar' : '-has-no-vertical-scrollbar';
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollBarWidth}px`);
    document.documentElement.classList.add(scrollBarClass);
  }
}

$(() => {
  window.App = new App();
});
